import { createFileRoute } from '@tanstack/react-router';
import { Card } from '@/components/Card/card';
import Icon from '@/components/Icon/Icon';
import { HStack, VStack } from '@/components/Layout';
import { Text } from '@/components/Typography/Text';
import { defaultNS, useTranslation } from '@/lib/i18n';
export const Route = createFileRoute('/_staff/wage-ledger/_layout/settings/')({
  component: SettingsRoute
});
function SettingsRoute() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.wageLedger.settings'
  });
  const sections = [{
    key: 'source',
    title: t($ => $.sections.source.title),
    description: t($ => $.sections.source.description),
    value: t($ => $.sections.source.value)
  }, {
    key: 'snapshot',
    title: t($ => $.sections.snapshot.title),
    description: t($ => $.sections.snapshot.description),
    value: t($ => $.sections.snapshot.value)
  }, {
    key: 'retention',
    title: t($ => $.sections.retention.title),
    description: t($ => $.sections.retention.description),
    value: t($ => $.sections.retention.value)
  }, {
    key: 'output',
    title: t($ => $.sections.output.title),
    description: t($ => $.sections.output.description),
    value: t($ => $.sections.output.value)
  }];
  return <VStack className="h-full min-h-0 gap-6 overflow-auto px-12 py-6">
      <VStack className="gap-1">
        <Text variant="h3">{t($ => $.title)}</Text>
        <Text variant="pSmall" className="text-neutral-muted-on-fill">
          {t($ => $.comingSoonNote)}
        </Text>
      </VStack>

      <VStack className="max-w-3xl gap-3">
        {sections.map(section => <Card key={section.key} className="p-4 shadow-xs">
            <HStack className="items-start justify-between gap-4">
              <VStack className="gap-1">
                <Text variant="labelSemiLarge">{section.title}</Text>
                <Text variant="pSmall" className="text-neutral-muted-on-fill">
                  {section.description}
                </Text>
              </VStack>
              <HStack className="shrink-0 items-center gap-1.5 rounded-md bg-neutral-subtle-fill px-2.5 py-1">
                <Icon iconName="SettingsIcon" className="size-3.5 text-neutral-muted-on-fill" />
                <Text variant="labelSmall" className="whitespace-nowrap">
                  {section.value}
                </Text>
              </HStack>
            </HStack>
          </Card>)}
      </VStack>
    </VStack>;
}